import { useMemo } from 'react';
import { TILE_SIZES, type TileSize } from 'dibs-buyer-product-tile/exports/BuyerProductTile.ts';

const CAROUSEL_ITEMS_TO_SHOW_RESP = 5;
const CAROUSEL_ITEMS_TO_SHOW_MOBILE = 1.5;

export const useSharedCarouselProps = ({
    isMobile,
}: {
    isMobile: boolean;
}): {
    fullWidth: boolean;
    gapSize: 'small' | 'medium' | 'large';
    tileSize: TileSize;
    itemsToShow: number;
    showArrows: boolean;
} => {
    const props = useMemo(
        () => ({
            fullWidth: !!isMobile,
            gapSize: 'small' as const,
            tileSize: TILE_SIZES.medium,
            itemsToShow: isMobile ? CAROUSEL_ITEMS_TO_SHOW_MOBILE : CAROUSEL_ITEMS_TO_SHOW_RESP,
            showArrows: !isMobile,
        }),
        [isMobile]
    );
    return props;
};
